module.exports = __webpack_public_path__ + "img/full1-min.155b837a.png";